module.exports = __webpack_public_path__ + "static/media/noun_scale tool_337727.beea788b.svg";